(function () {
  function applyReschWoodsCartFix() {
    if (typeof CartItems === 'undefined' || !CartItems.prototype) return false;
    if (CartItems.prototype.__reschWoodsStableCartFix) return true;

    CartItems.prototype.updateQuantity = function (line, quantity, event, name, variantId) {
      const isRemove = typeof CartRemoveButton !== 'undefined' && event.currentTarget instanceof CartRemoveButton;
      const eventTarget = isRemove ? 'clear' : 'change';
      const marker = typeof CartPerformance !== 'undefined'
        ? CartPerformance.createStartingMarker(`${eventTarget}:user-action`)
        : null;

      this.enableLoading(line);

      const action = quantity === 0 ? 'remove' : 'update';
      const quantityInput = this.querySelector(`#Quantity-${line}`) || this.querySelector(`#Drawer-quantity-${line}`);
      const lineVariantId = variantId || quantityInput?.dataset.quantityVariantId;
      const lineKey = quantityInput?.dataset.quantityLineKey;
      const linesUpdateDeferred = this.createCartLinesUpdateEvent(action, lineVariantId, quantity, lineKey);

      let sectionsToRender = [];
      try {
        sectionsToRender = this.getSectionsToRender() || [];
      } catch (e) {
        console.warn('Cart sections could not be resolved', e);
      }

      const request = {
        id: lineKey || line,
        quantity,
        sections_url: window.location.pathname,
      };
      if (sectionsToRender.length) request.sections = sectionsToRender.map((section) => section.section);

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: JSON.stringify(request) })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);

          if (parsedState.errors) {
            this.dispatchCartErrorEvent(parsedState.errors, 'INVALID');
            linesUpdateDeferred?.reject(new Error(String(parsedState.errors)));

            if (quantityInput) {
              quantityInput.value = quantityInput.getAttribute('value') || quantityInput.defaultValue || '1';
            }
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }

          this.resolveCartLinesUpdate(linesUpdateDeferred, parsedState);
          this.classList.toggle('is-empty', parsedState.item_count === 0);

          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');
          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          sectionsToRender.forEach((section) => {
            const sectionHtml = parsedState.sections?.[section.section];
            const root = document.getElementById(section.id);
            if (!sectionHtml || !root) return;

            const target = root.querySelector(section.selector) || root;
            const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const source = doc.querySelector(section.selector);
            if (source) target.innerHTML = source.innerHTML;
          });

          const items = Array.isArray(parsedState.items) ? parsedState.items : [];
          const updatedItem =
            (lineKey ? items.find((item) => item.key === lineKey) : null) ||
            (lineVariantId ? items.find((item) => String(item.variant_id) === String(lineVariantId)) : null);

          let message = '';
          if (action !== 'remove' && updatedItem && Number(updatedItem.quantity) !== Number(quantity)) {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedItem.quantity);
          }
          this.updateLiveRegions(line, message);

          if (action !== 'remove') {
            const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            const focusTarget = name && lineItem ? lineItem.querySelector(`[name="${name}"]`) : null;
            if (focusTarget) {
              cartDrawerWrapper ? trapFocus(cartDrawerWrapper, focusTarget) : focusTarget.focus();
            }
          } else if (parsedState.item_count === 0 && cartDrawerWrapper?.querySelector('.drawer__inner-empty')) {
            const empty = cartDrawerWrapper.querySelector('.drawer__inner-empty');
            const firstLink = empty.querySelector('a');
            if (firstLink) trapFocus(empty, firstLink);
          } else if (cartDrawerWrapper?.querySelector('.cart-item__name')) {
            trapFocus(cartDrawerWrapper, cartDrawerWrapper.querySelector('.cart-item__name'));
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items',
            cartData: parsedState,
            variantId: lineVariantId,
          });
        })
        .catch((e) => {
          this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = window.cartStrings.error;
          this.dispatchCartErrorEvent(window.cartStrings.error, 'SERVICE_UNAVAILABLE');
          linesUpdateDeferred?.reject(e);
        })
        .finally(() => {
          this.disableLoading(line);
          if (marker && typeof CartPerformance !== 'undefined') {
            CartPerformance.measureFromMarker(`${eventTarget}:user-action`, marker);
          }
        });
    };

    CartItems.prototype.updateLiveRegions = function (line, message) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const errorText = lineItemError?.querySelector('.cart-item__error-text');
      if (errorText) errorText.textContent = message || '';

      if (this.lineItemStatusElement) this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus =
        document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
      if (!cartStatus) return;
      cartStatus.setAttribute('aria-hidden', false);
      setTimeout(() => cartStatus.setAttribute('aria-hidden', true), 1000);
    };

    CartItems.prototype.enableLoading = function (line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems?.classList.add('cart__items--disabled');
      this.querySelectorAll(`#CartItem-${line} .loading__spinner, #CartDrawer-Item-${line} .loading__spinner`)
        .forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement?.blur?.();
      this.lineItemStatusElement?.setAttribute('aria-hidden', false);
    };

    CartItems.prototype.disableLoading = function (line) {
      const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
      mainCartItems?.classList.remove('cart__items--disabled');
      this.querySelectorAll(`#CartItem-${line} .loading__spinner, #CartDrawer-Item-${line} .loading__spinner`)
        .forEach((overlay) => overlay.classList.add('hidden'));
    };

    CartItems.prototype.__reschWoodsStableCartFix = true;
    return true;
  }

  if (!applyReschWoodsCartFix()) {
    document.addEventListener('DOMContentLoaded', applyReschWoodsCartFix, { once: true });
  }
})();
